import { ISO3166Alpha3 } from '@faire/web-api--source/indigofair/iso3166/ISO3166Alpha3';
import { SettingConst } from '@faire/web-api--source/types';

/**
 * TBD
 */
export const SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES =
  'SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES' as SettingConst<
    'SHIP_WITH_FAIRE_ENABLED_FROM_COUNTRIES',
    Array<keyof typeof ISO3166Alpha3>,
    'MAKER' | 'HELP_CENTER'
  >;
